import { importProvidersFrom } from '@angular/core';
import { DropdownModule } from '@coreui/angular';

export const dropdownProviders = importProvidersFrom(DropdownModule);
